import React, { useState } from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefault.module.css';
import CommonNoShippingModal from '../../../../components/CommonNoShippingModal/CommonNoShippingModal';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';


const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const BlockDefault = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
  } = props;
  const history = useHistory()

  const [isModalOpen, setModalOpen] = useState(false);

  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClasses = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  };

  const alignmentClass = alignmentClasses[alignment];

  // Check if user has address saved
  const currentUser = useSelector(state => state.user.currentUser);

  const hasAddressSaved = !!currentUser?.attributes?.profile?.protectedData?.ResidentialAddress;

  // Check if callToAction text is 'List Item' (or your specific value)
  const isListItemCTA = callToAction?.content === 'List Item';



  // Handle click for CTA field (override default Field behavior here)
  const handleCTAClick = e => {
    if (isListItemCTA && !hasAddressSaved) {
      e.preventDefault();
      setModalOpen(true);
    }
  };
  return (
    <BlockContainer id={blockId} className={classes}>
      <FieldMedia
        media={media}
        sizes={responsiveImageSizes}
        className={mediaClassName}
        options={options}
      />
      {hasTextComponentFields ? (
        <div className={classNames(textClassName, alignmentClass, css.text)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          {/* Render CTA with onClick override */}
          {isListItemCTA && currentUser && !hasAddressSaved ? (
            <button
              className={ctaButtonClass}
              onClick={handleCTAClick}
              type="button"
            >
              {callToAction?.content}
            </button>
          ) : (
            <Field data={callToAction} className={ctaButtonClass} options={options} />
          )}
        </div>
      ) : null}

      <CommonNoShippingModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        close={() => setModalOpen(false)}
        title="Address Required"
        subTitle="To continue listing your products to lend, please add your address. This ensures we connect you with borrowers in your area."
        btnText="Add Address"
        redirect={() => {
          setModalOpen(false);
          history.push('/account/residential-address'); // or use react-router navigate if available
        }}
      />
    </BlockContainer>
  );
};

export default BlockDefault;
